module.exports = __webpack_public_path__ + "media/images/logo-f0cd3f78a068a57b153462db0e2e6da5.svg";